import React from "react";
import { useNavigate } from "react-router-dom";
import { Banner, Button, LatestPosts } from "../Components";
import BuildBoostImage from "../assets/images/build_boost.jpg";
import OrganicShape from "../assets/images/inst.png";
import { handleDownload } from "../utils/globalFunctions";

const Offers = () => {
    const navigate = useNavigate();
    return (
        <>
            {/* Banner */}
            <Banner title={""} bgImage="bg-offers-banner" />

            {/* Main Offer Section */}
            <section className="bg-parchment py-12 lg:py-20 xl:py-20 2xl:py-20">
                <div className="max-w-8xl mx-auto px-6 pt-8 sm:px-8 sm:pt-0 xl:px-16 xl:pt-20">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 xl:gap-16 items-center">
                        {/* Left side - Offer Card (layered image with organic badge) */}
                        <div className="relative">
                            <div className="relative overflow-visible h-[360px] sm:h-[420px] md:h-[500px] xl:h-[600px] 2xl:h-[600px]">
                                {/* Photo base layer */}
                                <img
                                    className="absolute top-6 left-0 bottom-0 w-[80%] h-full sm:w-[86%] lg:w-[82%] xl:w-[78%] xl:h-full 2xl:w-[80%] 2xl:h-full object-cover"
                                    src={BuildBoostImage}
                                    alt="Banyan Build Boost interior"
                                />

                                {/* Organic badge overlay - positioned within the image boundaries */}
                                <div className="absolute -top-6 right-2 sm:-top-4 sm:right-4 md:-top-2 md:right-6 lg:-top-4 lg:right-10 xl:-top-6 xl:right-14 2xl:-top-10 2xl:right-16 z-10 pointer-events-none">
                                    <div className="relative drop-shadow-xl">
                                        <img
                                            className="w-[200px] sm:w-[200px] md:w-[220px] lg:w-[240px] xl:w-[280px] 2xl:w-[280px] h-auto block"
                                            src={OrganicShape}
                                            alt="Offer badge"
                                        />
                                        {/* Position text within the usable area of the shape */}
                                        <div className="absolute left-1/2 top-[50%] -translate-x-1/2 -translate-y-1/2 w-[78%] text-honeysuckle text-center">
                                            <p className="font-tobias text-4xl sm:text-xl md:text-3xl lg:text-3xl xl:text-4xl 2xl:text-4xl leading-tight">
                                                Banyan
                                            </p>
                                            <p className="font-tobias text-xl sm:text-xl md:text-3xl lg:text-3xl xl:text-4xl 2xl:text-4xl leading-tight mt-1">
                                                Build Boost
                                            </p>
                                            <p className="font-mori font-medium text-sm sm:text-base md:text-base lg:text-md xl:text-xl mt-4">
                                                $10K towards upgrades
                                            </p>
                                            <p className="font-mori font-medium text-sm sm:text-base md:text-base lg:text-md xl:text-xl">
                                                on your dream home
                                            </p>
                                            <p className="font-mori font-medium text-[10px] text-sm sm:text-base md:text-base lg:text-md xl:text-xl">
                                                *Conditions apply
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Right side - Offer Details */}
                        <div className="space-y-6 pt-10 sm:pt-10 md:pt-10 xl:pt-0">
                            <div>
                                <h2 className="text-gableGreen font-tobias text-3xl lg:text-4xl xl:text-5xl leading-tight mb-4">
                                    $10,000 towards building your dream home
                                    with the Banyan Build Boost
                                </h2>
                            </div>

                            <div className="space-y-4">
                                <p className="text-gableGreen font-mori font-medium text-base lg:text-lg leading-relaxed">
                                    Secure your block at Banyan Hill and we'll
                                    contribute $10,000 towards your build costs
                                    with our Banyan Build Boost. Whether you're
                                    a first-home buyer, starting a family, or
                                    looking for more room to grow, Banyan Hill
                                    is the place to begin your next chapter.
                                </p>

                                <ul className="space-y-2 text-gableGreen font-mori font-medium text-sm lg:text-base">
                                    <li className="flex items-start">
                                        <span className="w-2 h-2 bg-gableGreen rounded-full mt-2 mr-3 flex-shrink-0"></span>
                                        Generous blocks
                                    </li>
                                    <li className="flex items-start">
                                        <span className="w-2 h-2 bg-gableGreen rounded-full mt-2 mr-3 flex-shrink-0"></span>
                                        Nature at your doorstep
                                    </li>
                                    <li className="flex items-start">
                                        <span className="w-2 h-2 bg-gableGreen rounded-full mt-2 mr-3 flex-shrink-0"></span>
                                        Established community
                                    </li>
                                    <li className="flex items-start">
                                        <span className="w-2 h-2 bg-gableGreen rounded-full mt-2 mr-3 flex-shrink-0"></span>
                                        Spectacular views
                                    </li>
                                </ul>

                                <p className="text-gableGreen font-mori font-medium text-sm lg:text-base">
                                    And now, $10k to help you build your dream
                                    homes.
                                </p>
                            </div>

                            <div className="">
                                <p className="text-gableGreen font-mori font-medium text-sm lg:text-base mb-4">
                                    To find out more visit our sales office or
                                    download the brochure.
                                </p>
                                <p className="text-gableGreen font-mori font-medium text-sm lg:text-base">
                                    Start building where life's good!
                                </p>
                            </div>

                            {/* Call to Action Buttons */}
                            <div className="flex flex-col sm:flex-row gap-3 pt-6">
                                <Button
                                    id="download-brochure"
                                    title="Download Brochure"
                                    onClick={() => handleDownload("https://s3.intrapac.io/banyan-hill-pdf-files/boost/Intrapac%20-%20Banyan%20Build%20Boost%20Brochure.pdf")}
                                    variant="gableGreen"
                                    className="flex-1 text-center font-medium text-base 2xl:text-base cursor-pointer"
                                />
                                <Button
                                    id="house-and-land-catalogue"
                                    title="House and Land packages"
                                    onClick={() => handleDownload("https://s3.intrapac.io/banyan-hill-pdf-files/boost/Intrapac%20-%20Banyan%20Boost%20House%20and%20Land%20Brochure.pdf")}
                                    variant="gableGreen"
                                    className="flex-1 text-center font-medium text-base 2xl:text-base cursor-pointer"
                                />
                                <Button
                                    id="view-land-for-sale"
                                    title="View Land for Sale"
                                    onClick={() => navigate("/land-for-sale")}
                                    variant="gableGreen"
                                    className="flex-1 text-center font-medium text-base 2xl:text-base cursor-pointer"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Terms and Conditions */}
                <div className="max-w-8xl mx-auto px-6 pb-10 sm:px-10 sm:pb-10 lg:px-16 lg:pb-38 pt-8 sm:pt-10 lg:pt-20">
                    <div className="text-base text-gableGreen font-mori font-medium space-y-3 leading-relaxed w-full lg:w-[70%]">
                        <p>
                            *The Banyan Build Boost offer is available on all
                            land purchases at Banyan Hill from 1 October 2025 to
                            31 March 2026 (promotional period). Eligible
                            purchasers will receive a $10,000 (incl. GST) build
                            voucher, payable directly to their nominated
                            builder. Offer applies only to new contracts of sale
                            for land within the Banyan Hill development during
                            the promotional period.
                            <br />
                            The purchaser must proceed to enter a building
                            contract with a registered builder for a new
                            residential dwelling on the purchased lot.
                            <br />
                            The offer is available to qualified buyers
                            (“Purchasers") who enter into a contract ("Land
                            Contract") for the sale of an Eligible Lot: (a)
                            during the Promotion Period; (b) sign a land
                            contract in respect of an Eligible Lot (c) pay the
                            full deposit under the Land Contract and (d) settle
                            on the lot under the terms of the Land Contract.
                            <br />
                            Purchasers must deposit with a participating builder
                            within 90 days of settlement of the land and provide
                            Banyan Hill with a copy of the builder deposit
                            receipt with 5 days of signing their build contract.
                            <br />
                            Payment Conditions: The $10,000 voucher will be paid
                            directly to the purchaser’s nominated builder.
                            Payment will be made upon evidence of a signed
                            building contract and confirmation that the builder
                            deposit has been paid.
                            <br />
                            Only one voucher is available per lot purchased.
                            <br />
                            This offer is not transferable or redeemable for
                            cash. The Promotion is not available when building
                            with a non-participating builder. Banyan Hill
                            reserves the right to amend or withdraw this
                            promotion at any time without notice. Other terms
                            and conditions may apply as per the contract of
                            sale.
                            <br />
                            If the Purchaser named in the Contract nominates,
                            sells, transfers, gifts, or otherwise disposes with
                            the Property before settlement is complete, the
                            Vendor and participating Builder will not be obliged
                            to comply with its obligations in relation to the
                            Offer.
                            <br />
                            Banyan Hill gives no warranties and makes no
                            representations about any Builder's ability to enter
                            into or perform a Building Contract. Any form of
                            commitment fee or initial deposit paid by the
                            Purchaser to a participating Builder, the
                            administration of that payment is a matter between
                            the Purchaser and the Builder only. For more
                            information contact the Banyan Hill Sales Team on
                            1300 326 197 Info@banyanhill.com.au
                        </p>
                    </div>
                </div>
            </section>

            {/* Latest Posts */}
            <LatestPosts />
            {/* Latest Posts */}
        </>
    );
};

export default Offers;
